import { useContext, useEffect } from "react";
import { RyeButton } from "../rye/RyeButton";
import { RyeMainContentPanel } from "../rye/RyeMainContentPanel";
import { buildClasses } from "../utils/buildClasses";
import { AddNewAccountModal } from "./AddNewAccountModal";
import { useRyeModal } from "../rye/RyeModal";
import { AccountsList } from "./AccountsList";
import { prefetchInstitutionSearch } from "./institutionSearchPrefetch";
import { RyeEmptyState } from "../rye/RyeEmptyState";
import { AccountsContext } from "../firebaseio/AccountsContext";
import { LoadingInitialDataContext } from "../LoadUser";

export function AccountsScreen(): JSX.Element {
  const { openModal } = useRyeModal();
  const accounts = useContext(AccountsContext);
  const loading = useContext(LoadingInitialDataContext);
  const linkAccount = () => openModal(<AddNewAccountModal />);

  // Adding an account starts here, so get the bank search ready.
  useEffect(() => prefetchInstitutionSearch(), []);

  return (
    <RyeMainContentPanel
      title="Accounts"
      roundedTl={false}
      roundedBl={false}
      leadingActions={
        <RyeButton
          text="Add Account"
          icon="add"
          size="sm"
          variant="outlined"
          vibe="subdued"
          shadow="sm"
          onClick={linkAccount}
        />
      }
    >
      {!loading.accounts && accounts.size === 0 ? (
        <RyeEmptyState
          size="compact"
          icon="account_balance"
          title="Link your accounts"
          description="Connect your financial institutions and Bread will sync your account balances and transactions for you."
          actions={
            <RyeButton
              text="Link an account"
              icon="add"
              vibe="primary"
              variant="filled"
              onClick={linkAccount}
            />
          }
        />
      ) : (
        <div className={buildClasses("min-w-[1000px]")}>
          <AccountsList />
        </div>
      )}
    </RyeMainContentPanel>
  );
}
